<template>
  <div class="step-item d-flex align-items-center gap-2 justify-content-between w-100" :class="{ active: isActive, completed: isCompleted, pending: !isActive && !isCompleted }">
    <div class="d-flex align-items-center justify-content-between gap-2" :class="{ 'w-100': !useSlot }">
      <div class="step-icon" :class="{ 'completed': isCompleted, 'active': isActive }">
        <i :class="iconClass"></i>
      </div>
      <div class="step-content ml-2">
        <h6>{{ title }}</h6>
        <p>{{ subtitle }}</p>
      </div>
      <div v-if="useLoading" class="step-status-indicator">
        <div v-if="isActive" class="status-dot active"></div>
        <div v-else-if="isCompleted" class="status-dot completed"></div>
        <div v-else class="status-dot pending"></div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ProcessingStep',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isCompleted: {
      type: Boolean,
      default: false
    },
    useLoading: {
      type: Boolean,
      default: true
    },
    useSlot: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconClass() {
      return `fa ${this.icon}`;
    }
  }
}
</script>

<style scoped>
.step-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 12px;
  opacity: 0.6;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  border-left: 2px solid transparent;
}

.step-item.pending {
  opacity: 0.6;
  background: #f8f9fa;
  border-color: #e9ecef;
}

.step-item.active {
  opacity: 1;
  background: linear-gradient(135deg, #d4edda 0%, #f8f9fa 100%);
  border-color: #28a745;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.15);
  transform: translateY(-2px);
}

.step-item.completed {
  opacity: 1;
  background: linear-gradient(135deg, #e3f2fd 0%, #f8f9fa 100%);
  border-color: #20a8d8;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
}

.step-icon {
  width: 40px;
  height: 40px;
  background: #6c757d;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.step-icon.active {
  background: #28a745;
}

.step-icon.completed {
  background: #20a8d8;
}

.step-content {
  flex: 1;
}

.step-content h6 {
  margin: 0;
  font-weight: 600;
  color: #2c3e50;
  transition: color 0.3s ease;
}

.step-content p {
  margin: 0;
  font-size: 0.9rem;
  color: #6c757d;
  transition: color 0.3s ease;
}

.step-item.active .step-content h6 {
  color: #28a745;
}

.step-item.completed .step-content h6 {
  color: #20a8d8;
}

.step-status-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.status-dot.pending {
  background: #e9ecef;
  border: 2px solid #dee2e6;
}

.status-dot.active {
  background: #28a745;
  border: 2px solid #28a745;
}

.status-dot.completed {
  background: #007bff;
  border: 2px solid #007bff;
}

/* Animaciones solo cuando useLoading es true */
.step-item:has(.step-icon.active) .step-icon.active {
  animation: animation-pulse 2s infinite;
}

.step-item:has(.status-dot.active) .status-dot.active {
  animation: animation-pulse-2 1.5s infinite;
}

/* Responsive */
@media (max-width: 768px) {
  .step-item {
    padding: 0.75rem;
  }
  
  .step-icon {
    width: 32px;
    height: 32px;
    font-size: 1rem;
  }
  
  .step-content h6 {
    font-size: 0.9rem;
  }
  
  .step-content p {
    font-size: 0.8rem;
  }
}
</style>